module.exports = __webpack_public_path__ + "static/media/swot.1599fb74.pdf";